module.exports = __webpack_public_path__ + "static/media/roster--tablet.1c3481bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/roster--tablet.png
// module id = 632
// module chunks = 0